import { appRouterPaths } from 'services/navigation';
import { SubjectDifficultiesPage } from 'pages/SubjectDifficulties';
import type { AppRouteProps } from '../types';

export const subjectDifficultiesPageRoute: AppRouteProps = {
  path: appRouterPaths.subjectDifficulties,
  element: <SubjectDifficultiesPage />,
};
